module.exports = __webpack_public_path__ + "img/图片16.0b8c80bf.png";